import IComuna from "./comuna.interface";
import { Persona } from "./persona.model";
import IPrestador from "./prestador.interface";

export class Prestador extends Persona implements IPrestador {
    email: string;
    email_fiscalizacion: string;
    direccion: string;
    comuna: IComuna;
    telefono: string;
}
